import { validationLocalization } from '@bingads-webui-campaign-react/smart-i18n';
import { columnChooser } from './column-chooser';
import { filter } from './filter';
import { CronFormat } from './cron-format';
import { dateRange } from './date-range';
import { inlineDownload } from './inline-download';
import { inlineEdit } from './inline-edit';

export const legacyKeys = [
  validationLocalization, columnChooser, filter, CronFormat, dateRange, inlineDownload, inlineEdit];
